import z from "zod";
import {
  cancelAccount,
  recoverPassword,
  resetPassword,
  sendVerificationCode,
  signIn,
  signOut,
} from "@/lib/api/generated/endpoints/auth/auth";

const normalizeEmail = (email: string) => email.trim().toLowerCase();

export const signInSchema = z.object({
  email: z.email("无效的邮箱").transform(normalizeEmail),
  password: z.string().min(8, "密码长度至少为8位"),
});

export const resetPasswordSchema = z
  .object({
    oldPassword: z.string(),
    newPassword: z.string().min(8, "密码长度至少为8位"),
    reNewPassword: z.string().min(8, "密码长度至少为8位"),
  })
  .refine((data) => data.newPassword === data.reNewPassword, {
    message: "两次输入的密码不一致",
    path: ["reNewPassword"],
  });

export const recoverPasswordSchema = z
  .object({
    email: z.email("无效的邮箱").transform(normalizeEmail),
    verificationCode: z.string().min(6, "验证码长度至少为6位"),
    newPassword: z.string().min(8, "密码长度至少为8位"),
    reNewPassword: z.string().min(8, "密码长度至少为8位"),
  })
  .refine((data) => data.newPassword === data.reNewPassword, {
    message: "两次输入的密码不一致",
    path: ["reNewPassword"],
  });

export { cancelAccount, recoverPassword, resetPassword, sendVerificationCode, signIn, signOut };
